module.exports = __webpack_public_path__ + "img/project14_4.png.5919cfea.webp";